/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { LightInput, PrimaryButton, FieldWrapper, GeneralFormError } from 'ui';
import { FluidPreloader } from 'components/core/preloader';
import { Form, Field } from 'formik';
import Icon from 'components/core/icon';

import FooterShared from './layout/footer';
import HeaderShared from './layout/header';
import SubTitleShared from './layout/subtitle';
import s from './styles.module.scss';

const RestorePassword = ({ className = null, children = null, isSubmitting, ...props }) => {
  const { t } = useTranslation();

  return (
    <div className={cx(s.sharedForm, className)}>
      <HeaderShared>
        <Icon className={s.sharedFormLogo} icon={Icon.icons.logo} />
      </HeaderShared>
      <SubTitleShared>
        {t('contact_us_primary_locale')}
        <br />
        {t('contact_us_secondary_locale')}
      </SubTitleShared>
      <Form>
        <Field
          id="email"
          name="email"
          placeholder={t('email')}
          component={FieldWrapper}
          inputComponent={LightInput}
          className={s.sharedFormField}
        />
        <PrimaryButton
          type="submit"
          className={s.sharedFormSubmit}
          onClick={props.handleSubmit}
          isDisabled={isSubmitting}
        >
          {isSubmitting ? <FluidPreloader light /> : <>{t('reset_password')}</>}
        </PrimaryButton>
        <GeneralFormError error={props.errors.detail} />
      </Form>
      <FooterShared className="singleLink">
        <Link to="/#" className={s.sharedFormFooterLink}>
          <Icon className={s.sharedFormFooterLinkIcon} icon={Icon.icons.arrowLeft} />
          {t('back')}
        </Link>
        <Link to="/contact-us" className={s.sharedFormFooterLink}>
          {t('contact_us')}
        </Link>
      </FooterShared>
    </div>
  );
};

RestorePassword.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default RestorePassword;
